import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { createElement } from "react";

const fonts = ({name}: {name: IconProp}) => createElement(FontAwesomeIcon, {icon: name});

export default fonts;